// import external dependencies
import "jquery";
import Highway from "@dogstudio/highway";

// Import everything from autoload
//

// import local dependencies
import common from "./routes/common";
import home from "./routes/home";
import future from "./routes/future";
import present from "./routes/present";
import past from "./routes/past";
import news from "./routes/news";
import single from "./routes/single";
import cookies from "./routes/page-cookies";

import Fade from "./transitions/fade";

// Load Events

$(function() {
  common.init();
  // eslint-disable-next-line no-unused-vars
  const H = new Highway.Core({
    renderers: {
      "template-home": home,
      "template-future": future,
      "template-news": news,
      "template-present": present,
      "template-past": past,
      "template-cookies": cookies,
      "single-post": single,
    },
    transitions: {
      default: Fade,
    },
  });

  // Query admin bar links and detach them from Highway transitions
  const adminBarLinks = document.querySelectorAll("#wpadminbar a");
  H.detach(adminBarLinks);

  // Listen the `NAVIGATE_IN` event
  // This event is sent everytime a `data-router-view` is added to the DOM Tree
  H.on("NAVIGATE_IN", ({ location, to }) => {
    const oldHeader = document.querySelector(".js-header");
    const newHeader = to.page.querySelector(".js-header");

    const oldHeaderLogo = document.querySelector(".js-header-logo");
    const newHeaderLogo = to.page.querySelector(".js-header-logo");

    const oldNavLinks = document.querySelectorAll(".js-nav a");
    const newNavLinks = to.page.querySelectorAll(".js-nav a");

    const oldNavSubLinks = document.querySelectorAll(".js-nav-sub a");
    const newNavSubLinks = to.page.querySelectorAll(".js-nav-sub a");

    if (oldHeaderLogo && newHeaderLogo) {
      oldHeaderLogo.href = newHeaderLogo.href;
    }

    for (let i = 0; i < oldNavLinks.length; i++) {
      if (oldNavLinks[i]) {
        oldNavLinks[i].parentNode.classList.remove("is-active");
      }

      if (oldNavLinks[i] && newNavLinks[i]) {
        if (newNavLinks[i].href === location.href) {
          oldNavLinks[i].parentNode.classList.add("is-active");
        }

        oldNavLinks[i].href = newNavLinks[i].href;
        oldNavLinks[i].innerHTML = newNavLinks[i].innerHTML;
      }
    }

    for (let i = 0; i < oldNavSubLinks.length; i++) {
      if (oldNavSubLinks[i]) {
        oldNavSubLinks[i].parentNode.classList.remove("is-active");
      }

      if (oldNavSubLinks[i] && newNavSubLinks[i]) {
        if (newNavSubLinks[i].href === location.href) {
          oldNavSubLinks[i].parentNode.classList.add("is-active");
        }

        oldNavSubLinks[i].href = newNavSubLinks[i].href;
        oldNavSubLinks[i].innerHTML = newNavSubLinks[i].innerHTML;
      }
    }

    if (oldHeader && newHeader) {
      oldHeader.classList = newHeader.classList;
    }

    document.body.classList = to.page.body.classList;
  });
  // On page transition:
  H.on("NAVIGATE_END", ({ to, location }) => {
    // Query admin bar links, and new page's admin bar links
    const adminBarLinks = document.querySelectorAll("#wpadminbar a");
    const newAdminBarLinks = to.page.body.querySelectorAll("#wpadminbar a");
    // Replace every admin bar link's href value with new value
    for (let i = 0; i < newAdminBarLinks.length; i++) {
      adminBarLinks[i].href = newAdminBarLinks[i].href;
    }
    // Detach admin bar links from Highway transitions
    H.detach(adminBarLinks);

    // Replace language selector on desktop
    const oldLanguageSelectorDesktop = document.querySelector(
      ".js-lang-selector-desktop"
    );
    const newLanguageSelectorDesktop = to.page.body.querySelector(
      ".js-lang-selector-desktop"
    );
    oldLanguageSelectorDesktop.href = newLanguageSelectorDesktop.href;
    oldLanguageSelectorDesktop.innerHTML = newLanguageSelectorDesktop.innerHTML;

    // Replace language selector on mobile
    const oldLanguageSelectorMobile = document.querySelector(
      ".js-lang-selector-mobile"
    );
    const newLanguageSelectorMobile = to.page.body.querySelector(
      ".js-lang-selector-mobile"
    );
    oldLanguageSelectorMobile.href = newLanguageSelectorMobile.href;
    oldLanguageSelectorMobile.innerHTML = newLanguageSelectorMobile.innerHTML;

    // Analytics
    if (typeof gtag !== "undefined") {
      // eslint-disable-next-line
      gtag("config", "G-3LNXZ91DBD", {
        page_path: location.pathname,
        page_title: to.page.title,
        page_location: location.href,
      });
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/main.js